// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right-border[data-v-227feff6] {\n  border-right: 1px solid #e6e6e6;\n  border-right-width: 1px;\n  height: 40%;\n}\n.tableHeading[data-v-227feff6] {\n  background-color: #fdf1cc;\n}\n.customBorderWrapper[data-v-227feff6] {\n  border-radius: 8px 0px 0px 0px;\n}\n", ""]);
// Exports
module.exports = exports;
